/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Sold_BagsInputs */

const en_cargo_sold_bags = /** @type {(inputs: Cargo_Sold_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold Bags`)
};

const es_cargo_sold_bags = /** @type {(inputs: Cargo_Sold_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsas vendidas`)
};

/**
* | output |
* | --- |
* | "Sold Bags" |
*
* @param {Cargo_Sold_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_sold_bags = /** @type {((inputs?: Cargo_Sold_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Sold_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_sold_bags(inputs)
	return es_cargo_sold_bags(inputs)
});